import { reducer as favouritesReducer } from '@noths/polaris-client-user-favourites';
import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'connected-next-router';

import { reducer as accessibilityReducer } from 'src/redux/accessibility/slice';
import { reducer as basketReducer } from 'src/redux/basket/slice';
import { reducer as contactPartnerModalReducer } from 'src/redux/contactPartner/slice';
import { reducer as contentReducer } from 'src/redux/content/slice';
import { reducer as deliveryReducer } from 'src/redux/delivery/slice';
import { reducer as partnerReducer } from 'src/redux/partner/slice';
import { reducer as productReducer } from 'src/redux/product/slice';
import { reducer as productImagesCarouselReducer } from 'src/redux/productImagesCarousel/slice';
import { reducer as reviewsReducer } from 'src/redux/reviews/slice';
import { reducer as userReducer } from 'src/redux/user/slice';

export const combinedReducer = combineReducers({
  accessibility: accessibilityReducer,
  basket: basketReducer,
  contactPartnerModal: contactPartnerModalReducer,
  content: contentReducer,
  delivery: deliveryReducer,
  favourites: favouritesReducer,
  partner: partnerReducer,
  product: productReducer,
  productImagesCarousel: productImagesCarouselReducer,
  reviews: reviewsReducer,
  router: routerReducer,
  user: userReducer,
});

// Re-export ReduxApplicationState from types.ts to maintain backward compatibility
export type { ReduxApplicationState } from './types';
